import { createSlice } from "@reduxjs/toolkit";
import ApiTrails from "../../api/trail";

export const AuditChatTrailsSlice = createSlice({
  name: "chatTrails",
  initialState: {
    trails: null,
    hasMore: false,
    isLoading: false,
  },
  reducers: {
    // setTrails: (state, action) => ({
    //   ...state,
    //   trails: state.trails
    //     ? [
    //         ...state.trails,
    //         ...action.payload.filter((p) => !state.trails?.includes(p.id)),
    //       ]
    //     : action.payload,
    //   hasMore: action.payload?.length && action.payload?.length === 30,
    //   isLoading: false,
    // }),
    setTrails: (state, action) => {
      const existingIds = new Set((state.trails || []).map(t => t.id));
      const newItems = action.payload.filter(p => !existingIds.has(p.id));
      return {
        ...state,
        trails: state.trails ? [...state.trails, ...newItems] : action.payload,
        hasMore: action.payload?.length === 30,
        isLoading: false,
      };
    },
    resetTrails: (state) => ({
      ...state,
      trails: [],
      hasMore: false,
      isLoading: false,
    }),
    setLoading: (state) => ({ ...state, isLoading: true }),
  },
});

export const { setTrails, resetTrails, setLoading } =
  AuditChatTrailsSlice.actions;

export const fetchChatTrails = (query) => (dispatch) => {
  dispatch(setLoading());
  ApiTrails.getChatTrails(query).then((r) => {
    dispatch(setTrails(r.data.trails));
  });
};

export const clearChatTrails = () => (dispatch) => {
  dispatch(resetTrails());
};

export const selectChatTrails = (state) => state.chatTrails.trails;
export const selecthasMoreChatTrails = (state) =>
  state.chatTrails.hasMore;
export const selectChatTrailsLoading = (state) =>
  state.chatTrails.isLoading;

export default AuditChatTrailsSlice.reducer;
